module.exports = __webpack_public_path__ + "img/button_invite.d6403be8.png";